/**
 * filterByMember — Filters entities by tagged/assigned member.
 *
 * Shared across all entity pages (Address, Vehicle, Insurance, Healthcare, Financial).
 * "all" returns everything. Otherwise, includes entities tagged for everyone
 * (empty/missing taggedMembers) or specifically tagged for the given member ID.
 */

/** Empty state content when member filter hides all items */
export const MEMBER_FILTER_EMPTY = {
  title: 'No results for this member',
  subtitle: 'Select Family to view all items',
} as const;

export function filterByMember<T extends { assignedTo?: 'family' | string | string[]; taggedMembers?: string[] }>(
  entities: T[],
  memberFilter: string,
  _ownerId?: string,
): T[] {
  if (memberFilter === 'all') return entities;
  return entities.filter(entity => {
    // taggedMembers takes priority when present
    if (entity.taggedMembers !== undefined) {
      // Empty array = everyone
      if (entity.taggedMembers.length === 0) return true;
      return entity.taggedMembers.includes(memberFilter);
    }
    // assignedTo fallback
    if (entity.assignedTo === 'family') return true;
    if (Array.isArray(entity.assignedTo)) return entity.assignedTo.includes(memberFilter);
    if (typeof entity.assignedTo === 'string') return entity.assignedTo === memberFilter;
    // Unassigned → everyone (show for all members)
    return true;
  });
}
